import countries from 'data/containers/countries';

export const getCountryCodeByName = (name: string | null): string | null => {
  const country = countries.find((c) => c.label === name || c.value === name);
  return country ? country.code : null;
};

export const getCountryNameByCode = (code: string | null): string | null => {
  const country = countries.find((c) => c.code === code);
  return country ? country.label : null;
};
